module.exports = __webpack_public_path__ + "img/SpeciesTray_Icon.64001908.svg";